import * as React from "react"
import styled from "styled-components"

const CircleIndicator = styled.div<{ isSelected: boolean }>`
  cursor: pointer;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${(props) => (props.isSelected ? props.theme.colors.greyDark : props.theme.colors.greyDisabled)};
`
export default CircleIndicator
